import React, { Component } from "react";

import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import lodash from "lodash"; // library added for debounce functionality


class FleetTypeFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoader: false,
      dropdownOpen: false,
      dropdown_filter_value: 'member, active',
      controls: {
        member_type: 'member',
        fleet_status: 'active',
        fleet_type: '',
        is_all_fleets: false,
        club_name: "",
      }
    };
  }

  handleInputChange = (e) => {
    let { controls } = this.state;
    let controlName = e.target.name;
    if (controlName === 'member_type') {
      if (e.target.value === 'prospect') {
        controls.fleet_status = '';
        controls.fleet_type = '';
      }
    } else if (controlName === 'fleet_status') {
      if (controls.member_type === 'prospect') {
        return
      }
    } else if (controlName === 'fleet_type') {
      if (controls.member_type === 'prospect') {
        return
      }
    }
    else if (controlName === 'is_all_fleets') {
      if (e.target.value) {
        controls.member_type = '';
        controls.fleet_status = '';
        controls.fleet_type = '';
        controls.club_name = '';
      }
      controls[controlName] = !controls[controlName];
    }
    if (controlName !== 'is_all_fleets') {
      // if (controls.is_all_fleets) {
      //   return
      // }
      controls.is_all_fleets = false;
      controls[controlName] = e.target.value;
    }
    this.setState({
      controls
    })
  }

  toggle = () => {
    let { dropdownOpen, controls } = this.state;
    let { fleetDetailFilter } = this.props;
    if (!dropdownOpen) {
      if (fleetDetailFilter && Object.keys(fleetDetailFilter).length > 0) {
        controls = lodash.cloneDeep(fleetDetailFilter);
      } else {
        controls.member_type = 'member';
        controls.fleet_status = 'active';
        controls.fleet_type = '';
        controls.is_all_fleets = false;
        controls.club_name = "";
      }
    }
    this.setState({
      dropdownOpen: !dropdownOpen,
      controls
    });
  };

  applyFilter = () => {
    let { controls, dropdown_filter_value } = this.state;
    if (!controls.member_type && !controls.fleet_type && !controls.fleet_status) {
      controls.is_all_fleets = true;
    }
    if (controls.is_all_fleets) {
      dropdown_filter_value = 'All Fleet';
    } else {
      dropdown_filter_value = '';
      if (controls.member_type) {
        dropdown_filter_value = controls.member_type;
      }
      if (controls.fleet_status) {
        if (dropdown_filter_value.length > 0) {
          dropdown_filter_value += dropdown_filter_value.length > 0 && ', ';
        }
        dropdown_filter_value += controls.fleet_status;
      }
      if (controls.fleet_type) {
        if (dropdown_filter_value.length > 0) {
          dropdown_filter_value += dropdown_filter_value.length > 0 && ', ';
        }
        dropdown_filter_value += controls.fleet_type;
      }
      if (controls.club_name) {
        if (dropdown_filter_value.length > 0) {
          dropdown_filter_value += dropdown_filter_value.length > 0 && ', ';
        }
        dropdown_filter_value += controls.club_name;
      }
    }

    this.props.applyFilter(controls);
    this.setState({
      dropdownOpen: false,
      dropdown_filter_value
    });

  }

  resetFilter = () => {
    this.props.applyFilter({});
    this.setState({
      controls: {
        member_type: 'member',
        fleet_status: 'active',
        fleet_type: '',
        is_all_fleets: false,
        club_name: '',
      },
      dropdown_filter_value: 'member, active'
    }, () => {
      this.toggle();
    });
  }




  render() {
    let { controls } = this.state;
    return (
      <>

        <Dropdown
          group
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
          size="sm"
          className="dropdown-toggle-ho-all-india-filter-wrapper"
        >
          <DropdownToggle
            color="white"
            caret
            className="dropdown-toggle-ho-all-india-filter 
            text-capitalize All-Fleets-DropdownlLbl form-control"
          >
            {this.state.dropdown_filter_value}
          </DropdownToggle>

          <DropdownMenu className="dropdown-toggle-fleet-type-filter">
            {/* {this.state.isLoader && <CustomSpinner />} */}
            <div className="custom-dropdown-header">
              <span className="custom-dropdown-header-title cursor-pointer" style={{ marginLeft: '10px' }}>
                Filter
              </span>
              <img
                className="cursor-pointer"
                src="/images/close1.svg"
                onClick={this.toggle}
                alt="close1"
              />
            </div>
            <Row
              className="p-2"
              style={{ margin: "-5px", marginTop: "10px" }}
            >
              <Col className="pb-2">
                <label className="custom-checkboax1--container">
                  <input type="checkbox" name="is_all_fleets" checked={controls.is_all_fleets}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                  <span className="checkmark1" />
                </label>&nbsp;&nbsp;<span className="dropdown-toggle-fleet-type-filter-sub-lbl">All Fleets</span>
              </Col>
              <Col xl="12" md="12" xs="12" >
                <Label className="dropdown-toggle-fleet-type-filter-lbl">Membership Type</Label>
              </Col>
              <Col xl="12" md="12" xs="12">
                <Row>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="member"
                            checked={this.state.controls.member_type === 'member' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'member_type', value: 'member' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Member</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="prospect" checked={this.state.controls.member_type === 'prospect' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'member_type', value: 'prospect' } })} />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Prospect</span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row
              className="pl-2 pb-2 pr-2 pt-0 mt-0"
              style={{ margin: "-5px" }}
            >
              <Col xl="12" md="12" xs="12" >
                <Label className="dropdown-toggle-fleet-type-filter-lbl">Fleet Status</Label>
              </Col>
              <Col xl="12" md="12" xs="12">
                <Row>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" style={{ opacity: controls.member_type === 'prospect' ? 0.6 : 1 }}>
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="active"
                            checked={this.state.controls.fleet_status === 'active' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'fleet_status', value: 'active' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Active</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row"
                        style={{ opacity: controls.member_type === 'prospect' ? 0.6 : 1 }}>
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="inactive" checked={this.state.controls.fleet_status === 'inactive' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'fleet_status', value: 'inactive' } })} />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Inactive</span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row
              className="pl-2 pb-2 pr-2 pt-0 mt-0"
              style={{ margin: "-5px" }}
            >
              <Col xl="12" md="12" xs="12" >
                <Label className="dropdown-toggle-fleet-type-filter-lbl">Club Name</Label>
              </Col>
              <Col xl="12" md="12" xs="12">
                <Row>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value=""
                            checked={this.state.controls.club_name === '' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: '' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>All</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="blue"
                            checked={this.state.controls.club_name === 'blue' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: 'blue' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Blue</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="gold"
                            checked={this.state.controls.club_name === 'gold' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: 'gold' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Gold</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="diamond"
                            checked={this.state.controls.club_name === 'diamond' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: 'diamond' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Diamond</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="platinum"
                            checked={this.state.controls.club_name === 'platinum' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: 'platinum' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Platinum</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" >
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="chairman"
                            checked={this.state.controls.club_name === 'chairman' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'club_name', value: 'chairman' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Chairman</span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* hide changes 8aug23 */}
            {/* <Row
              className="pl-2 pb-2 pr-2  pt-0 mt-0"
              style={{ margin: "-5px" }}
            >
              <Col xl="12" md="12" xs="12" >
                <Label className="dropdown-toggle-fleet-type-filter-lbl">Fleet Type</Label>
              </Col>
              <Col xl="12" md="12" xs="12">
                <Row>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" style={{ opacity: controls.member_type === 'prospect' ? 0.6 : 1 }}>
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="direct"
                            checked={this.state.controls.fleet_type === 'direct' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'fleet_type', value: 'direct' } })}
                          />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Direct</span>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="6" xs="6">
                    <FormGroup>
                      <div className="d-flex-row" style={{ opacity: controls.member_type === 'prospect' ? 0.6 : 1 }}>
                        <label className="custom-checkboax-radio--container">
                          <input type="checkbox" name="enrollment_type" value="indirect" checked={this.state.controls.fleet_type === 'indirect' ? true : false}
                            onChange={(e) => this.handleInputChange({ target: { name: 'fleet_type', value: 'indirect' } })} />
                          <span className="checkmark-radio" />
                        </label>
                        <span className="dropdown-toggle-fleet-type-filter-sub-lbl" style={{ marginLeft: '10px' }}>Indirect</span>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row> */}
            <Row style={{ margin: "auto" }}>
              <Col
                xl="6"
                xs="6"
                md="6"
                className="text-align-right mt-3"
                style={{ padding: "0px" }}
              >
                <Button
                  className="mb-1 mr-1 btn-pill action-button profile-cancel-button"
                  color="dark"
                  style={{ width: '100px' }}
                  onClick={() => {
                    this.resetFilter();
                  }}
                >
                  Reset
                </Button>
              </Col>
              <Col xl="6" xs="6" md="6" className="text-align-right mt-3">
                <Button
                  className="mb-1 mr-1 btn-pill action-button profile-save-button"
                  color="warning"
                  style={{ width: '100px' }}
                  onClick={(e) => {
                    this.applyFilter(e);
                  }}
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </DropdownMenu>
        </Dropdown>

      </>
    );
  }
}

export default FleetTypeFilter;
